export default __webpack_public_path__ + "static/malgorzata-mock1_small-7e24036f130f9d54b256a9994b52758b.jpg";